import * as actionTypes from "./actionTypes";

export const getAllCompanyData = (companyData, total) => {
    return {
        type: actionTypes.GET_COMPANY_DATA,
        companyData: companyData,
        total: total,
    };
};

export const setTotal = (total) => {
    return {
        type: actionTypes.SET_TOTAL_COMPANY,
        total: total,
    };
}

export const setCompanyLoader = (loaderValue) => {
    return {
        type: actionTypes.SET_COMPANY_LOADER,
        loaderValue: loaderValue,
    }
}

export const companyPageIncreament = () => {
    return {
        type: actionTypes.COMPANY_PAGE_INCREAMENT,
    }
}

export const clearCompanyData = () => {
    return {
        type: actionTypes.CLEAR_COMPANY_DATA,
    };
};

export const updateCompanyPost = (singlePost) => {
    return {
        type: actionTypes.UPDATE_COMPANY_POST,
        post: singlePost,
    };
}